import React, { ReactNode } from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";

import { useCheckScreenWidth } from "@util/hooks";

interface Props {
  width?: string;
  children: ReactNode;
  placement?: "right" | "left" | "top" | "bottom";
  duration?: number;
  visible: boolean;
  onClose: () => void;
}

const MenuDrawer = (props: Props) => {
  const { isTabletWidth, isMobileWidth } = useCheckScreenWidth();

  return (
    <Drawer
      open={props.visible}
      onClose={props.onClose}
      direction={props.placement ?? "right"}
      style={{
        width: isTabletWidth || isMobileWidth ? "100%" : "40%",
        height: "100dvh",
        overflow: "auto",
      }}
      duration={props.duration}
    >
      {props.children}
    </Drawer>
  );
};

export default MenuDrawer;
